import React, { createContext, useContext, useEffect, useState } from "react";
import usePagination from "../../hooks/usePagination";
import { SortBy } from "../DiscountsProvider";
import { ActiveFilter } from "../../components/ui/FilterSearch";

interface IProps {
  children: React.ReactNode;
}

interface IAgentsLogsActivityContext {
  page: number;
  limit: number;
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;
  sortBy: SortBy;
  setSortBy: (sort: SortBy) => void;
  activeFilters: Record<string, ActiveFilter>;
  setActiveFilters: (filters: Record<string, ActiveFilter>) => void;
}

const AgentsLogsActivityContext = createContext<IAgentsLogsActivityContext>({
  activeFilters: {},
  page: 0,
  limit: 20,
  setPage: () => ({}),
  setLimit: () => ({}),
  sortBy: {
    by: "id",
    order: false,
  },
  setSortBy: () => null,
  setActiveFilters: () => null,
});

const AgentsLogsHistoryProvider = ({ children }: IProps): React.ReactElement => {
  const { page, setPage, limit, setLimit } = usePagination();
  const [activeFilters, setActiveFilters] = useState<Record<string, ActiveFilter>>({});

  const [sortBy, setSortBy] = useState<SortBy>({
    by: "log_time",
    order: false,
  });
  useEffect(() => {
    setPage(0);
  }, [limit, activeFilters]);

  return (
    <AgentsLogsActivityContext.Provider
      value={{
        activeFilters,
        setActiveFilters,
        page,
        limit,
        sortBy,
        setPage,
        setLimit,
        setSortBy,
      }}
    >
      {children}
    </AgentsLogsActivityContext.Provider>
  );
};

export default AgentsLogsHistoryProvider;
export const useAgentsLogsHistoryContext = (): IAgentsLogsActivityContext =>
  useContext(AgentsLogsActivityContext);
